import React, { useState } from "react";
import { Upload } from "antd";
import { uploadVideoFile } from "../../utils/uploadVideoFile";
import KoIcon from '@kwapio/icons';
import KoButton from "packages/button";
import KoLoader from "packages/loader";

export const UploadVideoButton = ({editor, onUpdateAttachment, lookupId, workspaceId, commentId, folderId, disabled}) => {
  const [loading, setLoading] = useState(false);

  const beforeUpload = async(file) => {
    await uploadVideoFile(editor, file, onUpdateAttachment, lookupId, workspaceId, commentId, setLoading, folderId);
    return false;
  };

  return (
    <>
      {loading&& <KoLoader/>}
      <Upload
        beforeUpload={beforeUpload}
        showUploadList={false}
        disabled={disabled}
        accept="video/*"
      >
        <KoButton  disabled={disabled} type="text" iconBtn icon={<KoIcon width={20} height={20} name="VideoOutlined" />}/>
      </Upload>
    </>
  );
};
